// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { Message, Conversation, UserProfile, Image, UserAccount } = initSchema(schema);

export {
  Message,
  Conversation,
  UserProfile,
  Image,
  UserAccount
};